import { render } from "./AboutUsDescription.vue?vue&type=template&id=5a675518&scoped=true"
import script from "./AboutUsDescription.vue?vue&type=script&lang=js"
export * from "./AboutUsDescription.vue?vue&type=script&lang=js"

import "./AboutUsDescription.vue?vue&type=style&index=0&id=5a675518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a675518"]])

export default __exports__